import { Typography } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'
import { defaultPalette } from '../../../theme/idsTheme'

const FullScreenCalloutAccessModeExpandedContent: React.FC = () => (
    <Typography sx={{ fontSize: '0.875rem' }}>
        Pour en savoir plus sur la réglementation de la PGSSI-S, ou pour obtenir de l’aide afin de régulariser votre
        situation,{' '}
        <Link
            to={window._env_.REACT_APP_HELP_CENTER_PGSSI_RPPS ?? ''}
            target="_blank"
            rel="noreferrer"
            style={{ color: defaultPalette.orangeWarning.main }}
        >
            consultez cet article du centre d’aide
        </Link>
        .
    </Typography>
)
export default FullScreenCalloutAccessModeExpandedContent
